import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const currentYear = new Date().getFullYear();

const FooterDetails: React.FC = () => {
  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='space-around'
      gap={1}
      flexDirection={'column'}
    >
      <Typography variant='body1' color={(theme) => theme.palette.grey[300]}>
        The Website is operated by EPICBYTE LTD, Company No 16230898, 117 Mayfield Road, Dagenham,
        England, RM8 1XJ, Phone: +447418320067.
      </Typography>

      <Typography
        variant='body1'
        align='center'
        fontWeight={300}
        color={(theme) => theme.palette.grey[300]}
      >
        ©{currentYear} Drop.Skin All rights reserved
      </Typography>
    </Box>
  );
};

export default FooterDetails;
